import React from 'react'

// Styles
import { StyledPill } from './DiscoverNewContentPill.styles'

const DiscoverNewContentPill: React.FC = () => {
  return <StyledPill variant={{ kind: 'secondary' }}>New</StyledPill>
}

export default DiscoverNewContentPill
